import { useState } from 'react'
import type { PuzzleRendererProps } from '@/game/PuzzleRenderer'

type Item = { id: string; label: string; imageUrl?: string }
type Config = { items?: Item[] }

/** Arrange items. Move up/down buttons keep it usable on touch screens. Submits { orderedIds }. */
export function OrderingPuzzle({ puzzle, onSubmit, disabled }: PuzzleRendererProps) {
  const items = (puzzle.publicConfig as Config).items ?? []
  const [order, setOrder] = useState<string[]>(() => items.map((i) => i.id))
  const byId = new Map(items.map((i) => [i.id, i]))

  function move(index: number, delta: number) {
    const target = index + delta
    if (target < 0 || target >= order.length) return
    setOrder((o) => {
      const next = [...o]
      const [moved] = next.splice(index, 1)
      next.splice(target, 0, moved as string)
      return next
    })
  }

  return (
    <div className="puzzle-form">
      <ol className="ordering" aria-label="Your order">
        {order.map((id, index) => {
          const item = byId.get(id)
          if (!item) return null
          return (
            <li key={id} className="ordering-item">
              <span className="ordering-index">{index + 1}</span>
              {item.imageUrl && <img src={item.imageUrl} alt="" className="ordering-thumb" />}
              <span className="ordering-label">{item.label}</span>
              <span className="ordering-controls">
                <button type="button" onClick={() => move(index, -1)} disabled={disabled || index === 0} aria-label={`Move ${item.label} up`}>
                  ▲
                </button>
                <button
                  type="button"
                  onClick={() => move(index, 1)}
                  disabled={disabled || index === order.length - 1}
                  aria-label={`Move ${item.label} down`}
                >
                  ▼
                </button>
              </span>
            </li>
          )
        })}
      </ol>
      <button type="button" className="primary" disabled={disabled} onClick={() => void onSubmit({ orderedIds: order })}>
        {disabled ? 'Checking…' : 'Submit order'}
      </button>
    </div>
  )
}
